<div class="bg-[#0A0E1F] text-white py-10 px-4">
  <!-- <div class="max-w-7xl mx-auto"> -->
  <!-- Header -->
  <!-- <div class="text-left lg:text-left mb-16 lg:mb-20">
          <h2 class="text-purple-400 text-lg font-semibold mb-2 tracking-wide">How it work</h2>
          <h1 class="text-white text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 max-w-2xl">
            Easiest Way To Picking a Number
          </h1>
          <p class="text-gray-400 text-lg max-w-2xl leading-relaxed">
            Picking your lucky numbers has never been this simple. With our user-friendly 
            interface, you can pick a number in seconds — no confusing steps or tricky forms. 
            Just tap, select, and get ready to win!
          </p>
        </div> -->

<div class="flex flex-col items-center text-center">
    <h2
      class="lg:text-[22px] text-white font-libre font-bold text-[18px] leading-[27px]"
    >
      <span class="text-[#19E4E0] border-b-2 border-[#19E4E0]">Event Drops</span>
      How it works
    </h2>
    <h1 class="text-2xl lg:text-[42px] font-bold mt-2">
      3 Simple Steps to Lock In Your Bonus
    </h1>
    <p
      class="lg:mt-3 mt-1 text-[12px] lg:text-[16px] text-gray-400 text-center max-w-3xl px-4"
    >
      Securing your daily campaign tokens has never been this simple. With our
      user-friendly interface, you can select your entry tier in seconds — no confusing
      steps or tricky rules. Just tap, confirm, and get ready to climb the ranks!
    </p>
  </div>
  <!-- Mobile Layout -->
  <!-- <div class="lg:hidden">
    <div class="space-y-12">
      <div *ngFor="let step of steps; let i = index" class="text-center group">
        <div class="relative mb-6">
          <div
            class="w-20 h-20 bg-gradient-to-br from-purple-600 to-purple-700 rounded-full flex items-center justify-center mx-auto shadow-2xl shadow-purple-500/25 group-hover:scale-110 transition-transform duration-300">
            <span class="text-white text-3xl font-bold">{{ step.number }}</span>
          </div>
          <div
            class="absolute -bottom-2 -right-2 w-12 h-12 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full flex items-center justify-center shadow-lg">
            <span class="text-2xl">{{ step.icon }}</span>
          </div>
        </div>
        <div class="space-y-4">
          <h3 class="text-white text-xl font-bold">
            {{ getTitle(step.title, step.highlightWord).before }}
            <span class="text-purple-400">{{ step.highlightWord }}</span>
            {{ getTitle(step.title, step.highlightWord).after }}
          </h3>
          <p class="text-gray-400 text-sm leading-relaxed max-w-xs mx-auto">
            {{ step.description }}
          </p>
        </div>
        <div *ngIf="i < steps.length - 1" class="mt-8 mb-4">
          <div class="w-px h-12 bg-gradient-to-b from-purple-500 to-transparent mx-auto"></div>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Desktop + Mobile Layout -->
<div class="bg-[#0A0E1F] py-0 lg:py-16 text-white text-center">
    <div class="max-w-7xl mx-auto py-4 lg:py-0 px-4">
      <div
        class="flex flex-col md:flex-row justify-between lg:items-start sm:items-center gap-12 relative"
      >
        <div class="absolute inset-0 pointer-events-none">
          <img
            class="hidden lg:block pl-6 mt-28"
            src="https://cmax.pages.dev/assets/landing-page/Line%207.svg"
            alt="Curved line"
          />
          <img
            class="block md:hidden h-[85%] mt-10"
            src="https://cmax.pages.dev/assets/landing-page/line-mobile.svg"
            alt="Curved line"
          />
        </div>

        <div class="flex flex-col items-center z-10">
          <div class="text-[150px] font-bold text-[#FFFFFF4D] leading-none">
            1
          </div>
          <div
            class="border border-[#19E4E0] rounded-2xl p-1 -mt-16 bg-[#13192E] shadow-[0px_4px_40px_0px_#19E4E066] w-[140px] h-[100px] flex items-center justify-center"
          >
            <img
              src="https://cmax.pages.dev/assets/landing-page/lottery-card.png"
              alt="Choose Event"
              class="w-[97px] h-[97px]"
            />
          </div>
          <h3 class="text-[12px] lg:text-[24px] mt-4 font-semibold">
            Choose Your <span class="text-[#19E4E0]">Campaign</span>
          </h3>
          <p class="text-[10px] lg:text-[16px] text-[#9196A5] max-w-xs mt-2">
            Pick from our five thrilling token pool events, featuring popular gameplay 
            arenas. Explore one — or unlock them all!
          </p>
        </div>

        <div class="flex flex-col items-center z-10">
          <div class="text-[150px] font-bold text-[#FFFFFF4D] leading-none">
            2
          </div>
          <div
            class="border border-[#19E4E0] rounded-2xl p-1 -mt-16 bg-[#13192E] shadow-[0px_4px_40px_0px_#19E4E066] w-[140px] h-[100px] flex items-center justify-center"
          >
            <img
              src="https://cmax.pages.dev/assets/landing-page/lottery-balls.png"
              alt="Select Zones"
              class="w-[104px] h-[104px]"
            />
          </div>
          <h3 class="text-[12px] lg:text-[24px] mt-4 font-semibold">
            Select Your <span class="text-[#19E4E0]">Tiers</span>
          </h3>
          <p class="text-[10px] lg:text-[16px] text-[#9196A5] max-w-xs mt-2">
            It’s all about fun! Choose your event slots manually or let the 
            system auto-select them for you. Either way, you're in the pool!
          </p>
        </div>

        <div class="flex flex-col items-center z-10">
          <div class="text-[150px] font-bold text-[#FFFFFF4D] leading-none">
            3
          </div>
          <div
            class="border border-[#19E4E0] rounded-2xl p-1 -mt-16 bg-[#13192E] shadow-[0px_4px_40px_0px_#19E4E066] w-[140px] h-[100px] flex items-center justify-center"
          >
            <img
              src="https://cmax.pages.dev/assets/landing-page/treasure-box.png"
              alt="Check Rewards"
              class="w-[104px] h-[104px]"
            />
          </div>
          <h3 class="text-[12px] lg:text-[24px] mt-4 font-semibold">
            Check Your <span class="text-[#19E4E0]">Results</span>
          </h3>
          <p class="text-[10px] lg:text-[16px] text-[#9196A5] max-w-xs mt-2">
            Once event rounds close, check if you scored top rewards. Don't forget: bonus 
            milestones are updated dynamically at the end of each round!
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- </div> -->
</div>
